import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import PhotoSpotPreviewModal from './PhotoSpotPreviewModal'

export default function PhotoSpotsCollage({ spots = [] }) {
  const [selected, setSelected] = useState(null)

  if (!spots.length) {
    return null
  }

  return (
    <div className="space-y-4">
      <div className="flex flex-col gap-2 sm:flex-row sm:items-baseline sm:justify-between">
        <h2 className="text-2xl font-semibold">Photo Library</h2>
        <Link
          to="/photo-planner/list"
          className="btn-secondary-compact self-start sm:self-auto"
          title="View a complete list of all photo spots"
        >
          View as list
        </Link>
      </div>

      <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-6 gap-2 sm:gap-3">
        {spots.map((spot) => {
          const imageUrl = spot.images?.[0]?.asset?.url
          const altText = spot.images?.[0]?.alt || spot.name
          return (
            <button
              key={spot._id || spot.slug || spot.name}
              type="button"
              onClick={() => setSelected(spot)}
              className="group relative overflow-hidden rounded-lg border border-white/10 bg-white/5 focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-400/60"
              aria-label={`Open photo preview for ${spot.name}`}
            >
              {imageUrl ? (
                <img
                  src={imageUrl}
                  alt={altText}
                  loading="lazy"
                  className="h-24 w-full object-cover transition-transform duration-300 group-hover:scale-105 sm:h-28 md:h-32 lg:h-36"
                />
              ) : (
                <div className="h-24 w-full bg-white/5 sm:h-28 md:h-32 lg:h-36" />
              )}
            </button>
          )
        })}
      </div>

      {selected ? (
        <PhotoSpotPreviewModal spot={selected} onClose={() => setSelected(null)} />
      ) : null}
    </div>
  )
}
